import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  Checkbox,
  Alert,
  Link,
  Snackbar,
} from "@mui/material";
 
const countryCode = [
  { value: "+1", label: <><img src="https://flagcdn.com/w40/us.png" alt="USA" width="20px"/> +1 (USA)</> },
  { value: "+91", label: <><img src="https://flagcdn.com/w40/in.png" alt="India" width="20px"/> +91 (India)</> },
  { value: "+44", label: <><img src="https://flagcdn.com/w40/gb.png" alt="UK" width="20px"/> +44 (UK)</> },
  { value: "+61", label: <><img src="https://flagcdn.com/w40/au.png" alt="Australia" width="20px"/> +61 (Australia)</> },
  { value: "+81", label: <><img src="https://flagcdn.com/w40/jp.png" alt="Japan" width="20px"/> +81 (Japan)</> },
  { value: "+86", label: <><img src="https://flagcdn.com/w40/cn.png" alt="China" width="20px"/> +86 (China)</> },
  { value: "+49", label: <><img src="https://flagcdn.com/w40/de.png" alt="Germany" width="20px"/> +49 (Germany)</> },
  { value: "+33", label: <><img src="https://flagcdn.com/w40/fr.png" alt="France" width="20px"/> +33 (France)</> },
  { value: "+39", label: <><img src="https://flagcdn.com/w40/it.png" alt="Italy" width="20px"/> +39 (Italy)</> },
  { value: "+7", label: <><img src="https://flagcdn.com/w40/ru.png" alt="Russia" width="20px"/> +7 (Russia)</> },
  { value: "+55", label: <><img src="https://flagcdn.com/w40/br.png" alt="Brazil" width="20px"/> +55 (Brazil)</> },
  { value: "+27", label: <><img src="https://flagcdn.com/w40/za.png" alt="South Africa" width="20px"/> +27 (South Africa)</> },
  { value: "+52", label: <><img src="https://flagcdn.com/w40/mx.png" alt="Mexico" width="20px"/> +52 (Mexico)</> },
  { value: "+34", label: <><img src="https://flagcdn.com/w40/es.png" alt="Spain" width="20px"/> +34 (Spain)</> },
  { value: "+62", label: <><img src="https://flagcdn.com/w40/id.png" alt="Indonesia" width="20px"/> +62 (Indonesia)</> },
  { value: "+90", label: <><img src="https://flagcdn.com/w40/tr.png" alt="Turkey" width="20px"/> +90 (Turkey)</> },
  { value: "+82", label: <><img src="https://flagcdn.com/w40/kr.png" alt="South Korea" width="20px"/> +82 (South Korea)</> },
  { value: "+971", label: <><img src="https://flagcdn.com/w40/ae.png" alt="UAE" width="20px"/> +971 (UAE)</> },
  { value: "+234", label: <><img src="https://flagcdn.com/w40/ng.png" alt="Nigeria" width="20px"/> +234 (Nigeria)</> },
  { value: "+966", label: <><img src="https://flagcdn.com/w40/sa.png" alt="Saudi Arabia" width="20px"/> +966 (Saudi Arabia)</> },
  { value: "+92", label: <><img src="https://flagcdn.com/w40/pk.png" alt="Pakistan" width="20px"/> +92 (Pakistan)</> },
  { value: "+880", label: <><img src="https://flagcdn.com/w40/bd.png" alt="Bangladesh" width="20px"/> +880 (Bangladesh)</> },
  { value: "+20", label: <><img src="https://flagcdn.com/w40/eg.png" alt="Egypt" width="20px"/> +20 (Egypt)</> },
  { value: "+31", label: <><img src="https://flagcdn.com/w40/nl.png" alt="Netherlands" width="20px"/> +31 (Netherlands)</> },
  { value: "+46", label: <><img src="https://flagcdn.com/w40/se.png" alt="Sweden" width="20px"/> +46 (Sweden)</> },
  { value: "+32", label: <><img src="https://flagcdn.com/w40/be.png" alt="Belgium" width="20px"/> +32 (Belgium)</> },
  { value: "+41", label: <><img src="https://flagcdn.com/w40/ch.png" alt="Switzerland" width="20px"/> +41 (Switzerland)</> },
  { value: "+64", label: <><img src="https://flagcdn.com/w40/nz.png" alt="New Zealand" width="20px"/> +64 (New Zealand)</> },
  { value: "+48", label: <><img src="https://flagcdn.com/w40/pl.png" alt="Poland" width="20px"/> +48 (Poland)</> },
  { value: "+30", label: <><img src="https://flagcdn.com/w40/gr.png" alt="Greece" width="20px"/> +30 (Greece)</> },
  { value: "+351", label: <><img src="https://flagcdn.com/w40/pt.png" alt="Portugal" width="20px"/> +351 (Portugal)</> },
  { value: "+963", label: <><img src="https://flagcdn.com/w40/sy.png" alt="Syria" width="20px"/> +963 (Syria)</> },
  { value: "+380", label: <><img src="https://flagcdn.com/w40/ua.png" alt="Ukraine" width="20px"/> +380 (Ukraine)</> },
  { value: "+237", label: <><img src="https://flagcdn.com/w40/cm.png" alt="Cameroon" width="20px"/> +237 (Cameroon)</> },
  { value: "+255", label: <><img src="https://flagcdn.com/w40/tz.png" alt="Tanzania" width="20px"/> +255 (Tanzania)</> },
  { value: "+98", label: <><img src="https://flagcdn.com/w40/ir.png" alt="Iran" width="20px"/> +98 (Iran)</> },
  { value: "+374", label: <><img src="https://flagcdn.com/w40/am.png" alt="Armenia" width="20px"/> +374 (Armenia)</> }
];

// reCAPTCHA site key - replace with your actual site key
const RECAPTCHA_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"; // This is Google's test key, replace with your actual key
 
const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    smsConsent: false
  });
 
  const [selectedCountryCode, setSelectedCountryCode] = useState("+91");
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [recaptchaError, setRecaptchaError] = useState("");
  const recaptchaRef = useRef(null);
 
  // Add state for Snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // Load reCAPTCHA script
  useEffect(() => {
    // Add reCAPTCHA script only if it's not already in the document
    if (!window.grecaptcha) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=explicit`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // Initialize reCAPTCHA when script is loaded
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            try {
              window.grecaptcha.render("recaptcha-container", {
                sitekey: RECAPTCHA_SITE_KEY,
                callback: (token) => {
                  setRecaptchaToken(token);
                  setRecaptchaError("");
                },
                "expired-callback": () => {
                  setRecaptchaToken("");
                  setRecaptchaError("reCAPTCHA has expired, please verify again");
                }
              });
            } catch (error) {
              console.error("Error rendering reCAPTCHA:", error);
            }
          });
        }
      };
      document.body.appendChild(script);
    }

    // Cleanup function to prevent memory leaks
    return () => {
      const script = document.querySelector('script[src*="recaptcha/api.js"]');
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);
 
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
   
    if (name === "phone") {
      // Only allow digits
      const digitsOnly = value.replace(/\D/g, "");
     
      // Format as XXX-XXX-XXXX
      let formattedPhone = digitsOnly;
      if (digitsOnly.length > 3) {
        formattedPhone = digitsOnly.slice(0, 3) + "-" + digitsOnly.slice(3);
      }
      if (digitsOnly.length > 6) {
        formattedPhone = formattedPhone.slice(0, 7) + "-" + formattedPhone.slice(7);
      }
      // Limit to 12 characters (including hyphens)
      formattedPhone = formattedPhone.slice(0, 12);
     
      setFormData({
        ...formData,
        [name]: formattedPhone,
      });
    } else if (name === "email") {
      // For email field, only allow input in the format "something@gmail.com"
      // This restricts input to what could potentially be a valid Gmail address
      if (value === "" || /^[a-zA-Z0-9._-]+(@gmail\.com)?$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
 
    if (submitted) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
 
  const handleCodeChange = (event) => {
    setSelectedCountryCode(event.target.value);
  };
 
  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First Name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required";
   
    // Email validation specifically for Gmail
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._-]+@gmail\.com$/.test(formData.email)) {
      newErrors.email = "Please enter a valid Gmail address (example@gmail.com)";
    }
   
    // Phone validation for XXX-XXX-XXXX format (10 digits)
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone Number is required";
    } else {
      const digitsOnly = formData.phone.replace(/\D/g, "");
      if (digitsOnly.length !== 10) {
        newErrors.phone = "Phone number must be 10 digits";
      }
    }
   
    if (!formData.message.trim()) newErrors.message = "Message is required";
    
    // Validate reCAPTCHA
    if (!recaptchaToken) {
      newErrors.recaptcha = "Please complete the reCAPTCHA verification";
    }
    
    return newErrors;
  };
 
  // Add handler for closing Snackbar
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  // Reset reCAPTCHA
  const resetRecaptcha = () => {
    if (window.grecaptcha && recaptchaRef.current) {
      window.grecaptcha.reset();
      setRecaptchaToken("");
    }
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
 
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
     
      // Show success message in Snackbar
      setSnackbarMessage("Form submitted successfully!");
      setOpenSnackbar(true);
 
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        smsConsent: false
      });
 
      setSubmitted(false);
      resetRecaptcha();
    }
  };
 
  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Contact Us
      </Typography>
      <Typography
        variant="h6"
        component="h2"
        align="center"
        color="textSecondary"
        paragraph
        sx={{ mb: 5 }}
      >
        We're here to help with all your insurance needs
      </Typography>
 
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box sx={{ p: 2, bgcolor: "#ffcc00", color: "black", borderRadius: "8px" }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Get in Touch
            </Typography>
            <Typography variant="body2" gutterBottom>
              We are always available to answer any questions you may have. Call us anytime or complete the form below.
            </Typography>
          </Box>
        </Grid>
 
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "2px",
                  marginTop:"8px"
                }}
              >
                First Name
              </Typography>
              <TextField
                fullWidth
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                error={!!errors.firstName}
                helperText={errors.firstName}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "2px",
                  marginTop:"8px"
                }}
              >
                Last Name
              </Typography>
              <TextField
                fullWidth
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                error={!!errors.lastName}
                helperText={errors.lastName}
              />
            </Grid>
          </Grid>
 
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "19.6px",
              textAlign: "left",
              marginBottom: "2px",
              marginTop:"8px"
            }}
          >
            Email
          </Typography>
          <TextField
            fullWidth
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            error={!!errors.email}
            helperText={errors.email }
            sx={{ mt: 0 }}
           
          />
 
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "2px",
                }}
              >
                Code
              </Typography>
              <FormControl fullWidth>
                <Select value={selectedCountryCode} onChange={handleCodeChange}>
                  {countryCode.map((country) => (
                    <MenuItem key={country.value} value={country.value}>
                    {country.label}
                  </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={9}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "2px",
                }}
              >
                Phone Number
              </Typography>
              <TextField
                fullWidth
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                error={!!errors.phone}
                helperText={errors.phone}
                inputProps={{ maxLength: 12 }}
              />
            </Grid>
          </Grid>
 
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "19.6px",
              textAlign: "left",
              marginBottom: "2px",
              marginTop:"8px"
            }}
          >
            Comment or Message
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            error={!!errors.message}
            helperText={errors.message}
            sx={{ mt: 0 }}
          />
 
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              SMS Policy
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  name="smsConsent"
                  checked={formData.smsConsent}
                  onChange={handleInputChange}
                />
              }
              label={
                <Typography variant="body2">
                  By checking this box, you agree to receive SMS messages from{" "}
                  <strong>Del Toro Insurance</strong> Agency. You can reply STOP
                  to opt-out at any time. Reply HELP for customer care at{" "}
                  <Link href="tel:3053358676">(305) 335-8676</Link>. Message
                  and data rates may apply. See our{" "}
                  <Link href="/privacy-policy">Privacy Policy</Link> and{" "}
                  <Link href="/terms-and-conditions">Terms & Conditions</Link>.
                </Typography>
              }
            />
          </Box>
 
          {/* Google reCAPTCHA v2 */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Verification
            </Typography>
            <div 
              id="recaptcha-container" 
              ref={recaptchaRef}
              style={{ marginBottom: '10px' }}
            ></div>
            {errors.recaptcha && (
              <Typography color="error" variant="caption" display="block">
                {errors.recaptcha}
              </Typography>
            )}
            {recaptchaError && (
              <Typography color="error" variant="caption" display="block">
                {recaptchaError}
              </Typography>
            )}
          </Box>
 
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2, bgcolor: "#ffcc00", color: "black", "&:hover": { bgcolor: "#e6b800" } }}
          >
            Submit to get in touch
          </Button>
        </form>
      </Grid>
     
      {/* Success Message Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};
 
export default ContactUs;